/* Http Client */
import request from '@/utils/http/request'


export const _STATUS = {
    1: "轉讓中",
    2: "轉讓成功",
    3: "取消轉讓"
}
export const _STATUS_COLOR = {
    1: 'orange',
    2: 'green',
    3: '',
}
